import { css } from '@emotion/core';
import { colorsPalette, hexToRgba } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';
import { injectGlobal } from 'emotion/macro';
import MediaQueries from '../../../styles/Grid/MediaQueries';

const WIDGET_WIDTH = '360px';

export const chatTriggerWrapper = css({
  background: colorsPalette.white,
  borderRadius: '2px 2px 0 0',
  height: 47,
  textAlign: 'center',
  width: 140,

  '&.cx-side-button.cx-theme-light': {
    boxShadow: `0 0 24px ${hexToRgba(colorsPalette.black, 0.1)}`,

    '&:focus': {
      outlineColor: colorsPalette.teal,
    },
  },
});

export const chatTriggerText = css(typography.effra18, {
  color: colorsPalette.teal,
});

const titlebarStyles = css({
  '.cx-titlebar': {
    alignItems: 'center',
    borderBottom: `1px solid ${colorsPalette.grey10}`,
    display: 'flex',
    height: 92,
    padding: '0 20px 0 24px  !important',

    [MediaQueries.mdAndUp]: {
      height: 72,
    },

    '.cx-icon': {
      display: 'none',
    },

    '.cx-title': {
      ...typography.effra22,
      marginLeft: 0,
    },
  },
});

const chatControlsStyles = css({
  '.cx-buttons-window-control': {
    alignItems: 'center',
    display: 'flex',
    top: '18px !important',
    right: 20,

    [MediaQueries.mdAndUp]: {
      top: '10px !important',
    },

    'path.cx-svg-icon-tone1, rect.cx-svg-icon-tone1': {
      fill: colorsPalette.black,
    },
  },
});

const buttonBaseStyles = {
  ...typography.effra14Link,
  fontWeight: fontWeights.medium,
  height: '48px',
  padding: '17px 24px',
  width: '142px',
};

const buttonsStyles = css({
  '.cx-button-container': {
    'button.cx-btn': {
      margin: 0,
    },
  },

  '.cx-button-group': {
    height: 56,
    overflow: 'visible',

    'button.cx-btn': {
      whiteSpace: 'normal !important',
    },

    '.cx-btn-default': {
      ...buttonBaseStyles,
      color: colorsPalette.grey,
      background: colorsPalette.transparent,
      outline: `1px solid ${colorsPalette.grey20}`,
      ':hover, :focus': {
        outlineColor: colorsPalette.grey40,
      },
    },

    '.cx-btn-primary': {
      ...buttonBaseStyles,
      color: colorsPalette.white,
      background: colorsPalette.red,
      borderColor: `${colorsPalette.red} !important`,
      ':hover, :focus': {
        background: colorsPalette.red110,
        outlineColor: colorsPalette.red110,
      },
    },
  },
});

const footerStyles = css({
  '.cx-footer': {
    height: 52,
  },
});

const formStyles = css({
  '.cx-form': {
    ['table']: {
      marginBottom: 22,
    },

    '.cx-control-label': {
      ...typography.effra16,
      fontWeight: fontWeights.medium,
      color: colorsPalette.black,
    },

    '.cx-form-control': {
      ...typography.effra16,
      padding: '6px 7px',
      borderColor: colorsPalette.grey20,

      '&.cx-error': {
        borderColor: colorsPalette.red,
      },

      '&:not(.cx-error):focus': {
        border: `1px solid ${colorsPalette.teal} !important`,
      },

      '&::-webkit-input-placeholder': {
        color: colorsPalette.grey40,
      },

      '&::-moz-placeholder': {
        color: colorsPalette.grey40,
      },

      '&:-ms-input-placeholder': {
        color: colorsPalette.grey40,
      },

      '&:-moz-placeholder': {
        color: colorsPalette.grey40,
      },
    },
  },
});

const chatStyles = css({
  '.cx-input-container': {
    '.cx-message-input': {
      ...typography.effra16,
      color: colorsPalette.grey60,
      height: '40px !important',
    },
  },

  '.cx-message-group>.cx-message.cx-participant': {
    marginBottom: '12px !important',
  },

  '.cx-transcript': {
    '.cx-them.cx-agent.cx-participant': {
      '.cx-bubble': {
        background: colorsPalette.red,
        marginLeft: 50,
      },

      '.cx-bubble-arrow': {
        borderColor: colorsPalette.red,
        left: 43,
      },

      '.cx-bubble-arrow *': {
        fill: colorsPalette.red,
      },

      '.cx-name': {
        ...typography.effra16,
        color: colorsPalette.white,
        fontWeight: fontWeights.medium,
      },

      '.cx-bubble .cx-time': {
        ...typography.effra16,
        color: colorsPalette.red20,
      },

      '.cx-message-text': {
        ...typography.effra16,
        color: colorsPalette.white,
      },

      '.cx-svg-icon-tone1': {
        fill: colorsPalette.transparent,
      },

      '.cx-avatar.agent': {
        backgroundImage: 'url(https://i.imgur.com/i21g8PM.png)',
        backgroundPosition: 'center',
        height: 32,
        width: 32,
      },
    },

    '.cx-bubble': {
      background: colorsPalette.grey10,
    },

    '.cx-bubble-arrow': {
      borderColor: colorsPalette.grey10,
    },

    '.cx-name': {
      ...typography.effra16,
      color: colorsPalette.black,
      fontWeight: fontWeights.medium,
    },

    '.cx-bubble .cx-time': {
      ...typography.effra16,
      color: colorsPalette.grey60,
    },

    '.cx-message-text': {
      ...typography.effra16,
      color: colorsPalette.black,
    },
  },
});

const dialogStyles = css({
  '.cx-alert': {
    '.cx-wrapper': {
      padding: '0 17px 24px',
      marginTop: 16,
    },

    '#cx_chat_end_question, #cx_chat_confirm_close': {
      ...typography.effra16,
      fontWeight: fontWeights.medium,
      padding: '24px 0',
      textAlign: 'center',
    },
  },
});

const timeOutStyles = css({
  '.cx-widget.cx-toaster': {
    width: WIDGET_WIDTH,

    '.cx-body': {
      paddingBottom: 32,
      fontWeight: fontWeights.medium,
    },
  },
});
const focusStyles = css({
  '.cx-widget.cx-desktop.cx-theme-light': {
    '.cx-input-focus': {
      boxShadow: `0 1px 1px ${colorsPalette.teal} !important`,
      borderColor: `${colorsPalette.teal} !important`,
    },

    '* :focus': {
      outlineColor: colorsPalette.teal,

      '& svg': {
        border: `1px solid ${colorsPalette.teal} !important`,
      },
    },
  },

  '.cx-widget.cx-common-container.cx-theme-light': {
    '.cx-button-group button:focus': {
      border: 0,
      outlineColor: `${colorsPalette.teal} !important`,
    },

    'input:focus': {
      border: `1px solid ${colorsPalette.teal} !important`,
    },
  },
});

injectGlobal`
  ${timeOutStyles}
  ${focusStyles}

  .cx-widget.cx-common-container {
    font-family: 'effra', sans-serif;
    width: ${WIDGET_WIDTH};

    ${titlebarStyles}
    ${chatControlsStyles}
    ${buttonsStyles}
    ${footerStyles}
    ${formStyles}
    ${chatStyles}
    ${dialogStyles}
  }
`;
